import CouponCardTheme2 from "components/CouponCardTheme2";
import "./special-coupon-list.scss";

const SpecialCouponsList = ({ couponListsData }) => {
    return (
        <>
            <h2>Special Coupons </h2>
            <div className="coupon-list-item">
                {couponListsData && couponListsData.slice(0, 5).map((coupon) => {
                    return <CouponCardTheme2 coupon={coupon} />
                })}
            </div>
        </>
    );
}

export default SpecialCouponsList;